// src/routes/ThemeDetail.jsx
import { useLocation, useParams } from "react-router-dom";

import ThemeRenderer from "./ThemeRenderer";
import MenuService from "../../services/MenuService";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "lucide-react";


// Recursive function to find page by URL
const findPageByUrl = (pages, url) => {
  for (const page of pages) {
    if (page.url === url) return page;
    if (page.children?.length) {
      const found = findPageByUrl(page.children, url);
      if (found) return found;
    }
  }
  return null;
};

const ThemeDetail = () => {
  const location = useLocation();
  const currentPath = location.pathname; // e.g., "/test1/milestone"

  const { isLoading, error, data } = useQuery({
    queryKey: ["menu-list"],
    queryFn: MenuService.getList,
  });

  if (isLoading) {
    return <Loader style={{ height: "100vh", color: "#fff" }} />
  }
  if (error) return <div>Error loading page</div>;

  const page = findPageByUrl(data || [], currentPath);

  if (!page) return <div>Page not found</div>;

  return <ThemeRenderer pageData={page} />;
};

export default ThemeDetail;
